<div class="mb-6">
  <nz-steps [nzCurrent]="currentStep" nzSize="small">
    <nz-step [nzTitle]="'forgotPsd.stepEmail' | translate"></nz-step>
    <nz-step [nzTitle]="'forgotPsd.stepReset' | translate"></nz-step>
  </nz-steps>
</div>

@if (currentStep === 0) {
  <nz-alert
    class="mb-4"
    nzType="warning"
    [nzMessage]="'forgotPsd.noEmailTitle' | translate"
    [nzDescription]="'forgotPsd.noEmailDesc' | translate"
    nzShowIcon
  ></nz-alert>

  <nz-form-item>
    <nz-form-label nzRequired>{{ 'forgotPsd.emailLabel' | translate }}</nz-form-label>
    <nz-form-control [nzErrorTip]="'forgotPsd.emailError' | translate">
      <div class="flex gap-2">
        <input nz-input type="email" [formControl]="emailControl" placeholder="example@mail.kz">
        @if (codeSent) {
          <button nz-button type="button" (click)="changeEmail()">{{ 'forgotPsd.change' | translate }}</button>
        } @else {
          <button
            nz-button
            type="button"
            [nzLoading]="isSendingCode"
            [disabled]="emailControl.invalid"
            (click)="sendCode()"
          >
            {{ 'forgotPsd.getCode' | translate }}
          </button>
        }
      </div>
    </nz-form-control>
  </nz-form-item>

  @if (codeSent) {
    <nz-form-item>
      <nz-form-label nzRequired>{{ 'forgotPsd.codeLabel' | translate }}</nz-form-label>
      <nz-form-control [nzErrorTip]="'forgotPsd.codeError' | translate">
        <div class="flex gap-2">
          <input nz-input maxlength="6" inputmode="numeric" [formControl]="codeControl" placeholder="______">
          <button
            nz-button
            type="button"
            [nzLoading]="isConfirmingCode"
            [disabled]="codeControl.invalid"
            (click)="confirmCode()"
          >
            {{ 'forgotPsd.confirm' | translate }}
          </button>
        </div>
        <button
          nz-button
          nzType="link"
          type="button"
          class="mt-1 px-0"
          [nzLoading]="isSendingCode"
          [disabled]="resendCountdown > 0"
          (click)="sendCode()"
        >
          {{ resendCountdown > 0
            ? ('forgotPsd.resendCountdown' | translate:{seconds: resendCountdown})
            : ('forgotPsd.resend' | translate) }}
        </button>
      </nz-form-control>
    </nz-form-item>
  }
}

@if (currentStep === 1) {
  <nz-alert
    class="mb-2"
    nzType="success"
    [nzMessage]="'forgotPsd.confirmedTitle' | translate"
    [nzDescription]="'forgotPsd.confirmedDesc' | translate:{email: emailControl.value}"
    nzShowIcon
  ></nz-alert>
}
